import { render } from "./ServicesHeader.vue?vue&type=template&id=aee1b416"
import script from "./ServicesHeader.vue?vue&type=script&lang=js"
export * from "./ServicesHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__